// src/components/ui/Card.jsx

import { cn } from "../../../lib/utils";

export default function Card({ children, className, padding = 'p-6' }) {
  return (
    <div className={cn('bg-white rounded-xl shadow-sm border border-gray-200', padding, className)}>
      {children}
    </div>
  );
}